import translateJson from 'src/utils/translate.json';

export type TranslateKey = keyof typeof translateJson;

// TODO: - use i18next instead of a custom translation function
const translate = (key: TranslateKey, params?: Record<string, string | number>) => {
  let value: string = translateJson[key] ?? key;
  if (params) {
    Object.entries(params).forEach(([k, v]) => {
      value = value.replace(new RegExp(`\\{${k}\\}`, 'g'), String(v));
    });
  }
  return value;
};

export default translate;
